import {
  FaSignInAlt,
  FaUsers,
  FaShieldAlt,
  FaProjectDiagram,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-keycloak.png";

export const KEYCLOAK_CONSTANTS = {
  HERO: {
    title: "OneMind Services — Keycloak (One-Click Application) ",
    desc: "Secure your applications with OneMind’s fully managed Keycloak service. We provide seamless identity and access management, so you can focus on building great software.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Keycloak is an open-source identity and access management solution offering Single Sign-On (SSO), multi-factor authentication, user federation, and more. It simplifies securing applications and services by enabling authentication to be managed centrally.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure Keycloak instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high.  ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Keycloak server, default admin credentials, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "admin",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access the Keycloak admin console at: ",
      command: "http://<YOUR_INSTANCE_IP>:8080/auth ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration files are located in the directory ",
      location: "/opt/keycloak/  ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["8080 (HTTP) ", "8443 (HTTPS)"],
    },
    note: "Note :  Find the configuration files at /opt/keycloak/ for customized tweaks or backup.",
  },
  FEATURES: {
    items: [
      {
        icon: FaSignInAlt,
        title: "Single Sign-On (SSO)",
        text: "Allows users to authenticate once and access multiple applications.",
      },
      {
        icon: FaUsers,
        title: "User Federation",
        text: "Integrates with existing user directories like LDAP and Active Directory.",
      },
      {
        icon: FaShieldAlt,
        title: "Multi-Factor Authentication",
        text: "Supports additional authentication methods for enhanced security.",
      },
      {
        icon: FaProjectDiagram,
        title: "Protocol Support",
        text: "Supports standard protocols like OpenID Connect, OAuth 2.0, and SAML.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for Keycloak data and configurations. ",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with firewall rules, TLS ready, and access control configurations. ",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with load balancers for high availability. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Keycloak Official Docs",
    docsLink: "https://www.keycloak.org/documentation.html",
  },
};
